// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
// import "lib-flexible";
import "./style/resrt.css";
import { Carousel, CarouselItem } from "element-ui";
//import axios from "axios";
//import api from "./network/api";
//Vue.prototype.$api = api;
import axiosApi from "./api/axios";

import "element-ui/lib/theme-chalk/index.css";

import md5 from "js-md5";

//import VConsole from 'vconsole';
//let vconsole = new VConsole;
//export default vconsole;

Vue.config.productionTip = false;
Vue.use(Carousel);
Vue.use(CarouselItem);
//Vue.use(api);
//Vue.use(axios);
//Vue.prototype.$axios = axios;
Vue.use(axiosApi);
//Vue.use(md5);
Vue.prototype.md5 = md5;

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

router.beforeEach((to, from, next) => {
	if (to.meta.content) {
		let head = document.getElementsByTagName('head');
		let meta = document.createElement('meta');
		document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
		document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
		meta.content = to.meta.content;
		head[0].appendChild(meta)
	}
	if (to.meta.title) {
		document.title = to.meta.title;
	}
	next()
});


/* eslint-disable no-new */
window.app = new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js